import { Instagram } from "lucide-react";

export const SOCIALS = {
  instagram: "https://www.instagram.com/ozentya_pousse_cheveux/",
  instagramParis: "https://www.instagram.com/ozentyaparis/",
  tiktok: "https://www.tiktok.com/@ozentyapoussecheveu",
  pro: "https://www.ozentya.org",
};

function TikTok({ className }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5 2.6 2.6 0 0 1-2.6-2.6 2.6 2.6 0 0 1 3.4-2.47V9.67a5.7 5.7 0 0 0-6.5 5.63 5.7 5.7 0 0 0 5.7 5.7 5.7 5.7 0 0 0 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3a4.3 4.3 0 0 1-3.25-1.48Z" />
    </svg>
  );
}

export function SocialLinks({ className = "" }) {
  const cls = "flex h-11 w-11 items-center justify-center rounded-full border border-[var(--line)] text-[var(--parchment)] transition-colors duration-300 hover:border-[var(--gold)] hover:bg-[var(--gold)] hover:text-[var(--ink)]";
  return (
    <div className={`flex gap-3 ${className}`}>
      <a href={SOCIALS.instagramParis} target="_blank" rel="noopener noreferrer" aria-label="Instagram Ozentya Paris" data-testid="social-instagram-paris" className={cls}><Instagram className="h-5 w-5" /></a>
      <a href={SOCIALS.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram Ozentya pousse cheveux" data-testid="social-instagram" className={cls}><Instagram className="h-5 w-5" /></a>
      <a href={SOCIALS.tiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok Ozentya" data-testid="social-tiktok" className={cls}><TikTok className="h-5 w-5" /></a>
    </div>
  );
}
